
import React from 'react';

import Grid from '@mui/material/Grid';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import Typography from '@mui/material/Typography';

import Dieta from './Dieta';

export function Invitati(props) {

	const enabled = props.enabled;

	const [count, setCount] = React.useState('');

	const handleChange = (event) => {
		const c = event.target.value;
		setCount(c);
	};


	const items = [];
	for (let i = 0; i < count; i++) {
		items.push(<Dieta key={i} id={i} />);
	}

	return (
		<React.Fragment>
			{
				enabled && (
					<Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems="center">
						<Grid item xs={4} md={6}>
							<Typography variant='subtitle1' sx={{ marginTop: "20px", textAlign: "center", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold" }}>
								In quanti sarete?
							</Typography>
						</Grid>
						<Grid item xs={8} md={6}>
							<FormControl variant="standard" sx={{ m: 1, minWidth: 160 }}>
								<InputLabel id="partecipanti-label" sx={{fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold", color:"#fff"}}>Partecipanti</InputLabel>
								<Select
									required
									labelId="demo-simple-select-disabled-label"
									id="invitatiCount"
									name="invitatiCount"
									value={count}
									label="Partecipanti"
									onChange={handleChange}
									sx={{color: "#fff", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}
								>
									<MenuItem value={1} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}} >Solo io</MenuItem>
									<MenuItem value={2} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}>Saremo in 2</MenuItem>
									<MenuItem value={3} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}>Saremo in 3</MenuItem>
									<MenuItem value={4} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}>Saremo in 4</MenuItem>
									<MenuItem value={5} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}>Saremo in 5</MenuItem>
									<MenuItem value={6} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}>Saremo in 6</MenuItem>
									<MenuItem value={7} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}>Saremo in 7</MenuItem>
									<MenuItem value={8} sx={{color: "#000", fontFamily: '"Penna"', fontSize: "1.8rem", fontWeight: "bold"}}>Saremo in 8</MenuItem>
								</Select>
							</FormControl>
						</Grid>
					</Grid>
			)
			}
			{enabled && items}
		</React.Fragment>
	)
}

export default Invitati;